package game.entity

import game.Game
import game.Room

class AnimationEntity : Entity() {
    override fun onInit(game: Game, room: Room) {
        if (params.isNotEmpty()) {
            sprite = game.getSpriteById(params)
        }
    }

    override fun onAnimationComplete(game: Game) {
        game.currentRoom.removeEntity(this)
    }
}